import gql from 'graphql-tag';

export default gql`
mutation ReviewApprove(
        $uuids: String!
      ) {
    reviewApprove(uuids: $uuids) {
      __typename
    }
}
`;
